/* eslint-disable react/react-in-jsx-scope */
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import store from './redux/store';
import './App.css';
import Routers from './router/index';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/scrollbar.css';
import TableContextProvider from './contexts/tableContext';
import ErrorBoundary from './components/ErrorBoundary';
import { getCookies, setCookies } from './hooks/useCookies';
import envValues from './enviornment';

function AppShellFallback() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        textAlign: 'center',
        fontFamily: 'inherit',
      }}
    >
      <h2 style={{ color: '#28305f', marginBottom: 12 }}>Application error</h2>
      <p style={{ color: '#28305f', marginBottom: 20 }}>
        The admin app failed to start. Please reload the page.
      </p>
      <button
        type="button"
        style={{
          backgroundColor: '#39979d',
          color: '#fff',
          border: 'none',
          padding: '8px 20px',
          borderRadius: 6,
          cursor: 'pointer',
        }}
        onClick={() => window.location.reload()}
      >
        Reload page
      </button>
    </div>
  );
}

function App() {
  const [showBanner, setShowBanner] = useState(true);
  const cookieBannerControl = () => {
    setShowBanner(!showBanner);
    setCookies('showCookieBanner', false);
  };
  return (
    <Provider store={store}>
      <ErrorBoundary variant="global" fallback={<AppShellFallback />}>
        <div className="App">
          <TableContextProvider>
            <Routers />
          </TableContextProvider>
          <ToastContainer autoClose={2000} />
        </div>
      </ErrorBoundary>
      {showBanner &&
      envValues.REACT_APP_SHOW_COOKIE_BOX &&
      getCookies('showCookieBanner') !== 'false' ? (
        <div className="cookie-banner">
          <p>This website uses cookies to enhance user experience.</p>
          <button type="button" className="close" onClick={cookieBannerControl}>
            I Understand
          </button>
        </div>
      ) : null}
    </Provider>
  );
}
export default App;
